<template>
  <div>
    <div :class="isCollapse ? 'sys-name sys-coll' : 'sys-name'">后台管理</div>
    <div class="sider-bar">
      <el-menu
        :default-active="activeMenu"
        class="sider-menu"
        :collapse="isCollapse"
        @open="handleOpen"
        @close="handleClose"
        background-color="#304156"
        text-color="#bfcbd9"
        router
        active-text-color="#0089F5">
        <Item v-for="route in routes" :key="route.menuId" :item="route" :path="route.path" />
      </el-menu>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Item from './Item';

export default {
  name: 'SiderBar',
  components: {
    Item,
  },
  data() {
    return {
    };
  },
  computed: {
    activeMenu() {
      const route = this.pathLimits.find(item => item.path === this.$route.path);
      console.log(this.pathLimits, route, 'route');
      if (route) {
        return route.fromPath;
      }
      return this.$route.path;
    },
    ...mapGetters({
      pathLimits: 'pathLimits',
      routes: 'menuList',
      isCollapse: 'isCollapse',
    }),
  },
  created() {
    if (this.routes.length === 0) {
      console.log('routes');
      this.initMenu();
    }
  },
  methods: {
    handleOpen() {
    },
    handleClose() {
    },
    ...mapActions({
      initMenu: 'initMenu',
    }),
  },
};
</script>

<style lang="less" scoped>
  .sider-bar {
    height: calc(~'100vh - 60px');
    overflow-y: auto;
    overflow-x: hidden;
    background-color: rgb(48, 65, 86);
  }
  .sys-name {
    width: 220px;
    text-align: center;
    height: 60px;
    background-color: #2d637b;
    line-height: 60px;
    font-size: 18px;
    color: #fff;
    font-weight: 600;
  }
  .sys-coll {
    width: 80px;
    overflow: hidden;
  }
  .sider-menu:not(.el-menu--collapse) {
    width: 200px;
  }
  .el-menu {
    border-right: none;
  }
  .el-menu--collapse {
    width: 80px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/SiderBar.vue